import shuffle from 'lodash/shuffle';
import { Property } from '../../types/property';

/*
 * Returns agents logos urls in array, if more than 3 logos, return shuffled 3 or first 3
 */

const getAgentLogos = (
  property: Property,
  type: 'alternative' | 'premier' | 'standard' = 'standard',
  preventShuffle?: boolean,
): string[] | null => {
  const logos = property?.listingLogos && property?.listingLogos.filter((l) => l?.[type]).map((l) => l?.[type]);

  const shuffleLogos = () => {
    // can't shuffle when inside an infite loader due to the re-rendering
    if (!preventShuffle) return shuffle(logos).slice(0, 3);
    return logos.slice(0, 3);
  };

  return logos && logos.length > 3 ? shuffleLogos() : logos;
};

export default getAgentLogos;
